import type { ChangeEvent } from "react";
import styled from "styled-components";
import { hexToRGB } from "../../utils/style";
import { ErrorMessage } from "./ErrorMessage";
import { Typography } from "./Typography";

/**
 * [共通パーツ]テキスト入力欄
 */

export type StyledInputProps = {
  value?: string;
  number?: boolean;
  $error?: boolean;
  errorMessages?: string[];
  suffix?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  dataId?: string;
  disabled?: boolean;
  placeholder?: string;
};

export type InputProps = {
  value?: string;
  number?: boolean;
  error?: boolean;
  errorMessages?: string[];
  suffix?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  dataId?: string;
  disabled?: boolean;
  placeholder?: string;
};

const Container = styled.div`
  display: flex;
  height: 44px;
`;

const TypographyWrapper = styled(Typography)`
  padding-top: 10px;
  padding-left: 10px;
`;

const StyledInput = styled.input<StyledInputProps>`
  background-color: ${(props) =>
    props.$error
      ? hexToRGB(props.theme.colors.caution, 0.05)
      : props.theme.colors.inputFieldBackground};
  color: ${(props) => props.theme.colors.primaryText};
  font-size: ${(props) => props.theme.fontSize.small};
  padding: 13px 10px;
  border: 1px solid
    ${(props) =>
      props.$error
        ? props.theme.colors.caution
        : props.theme.colors.primaryBorder};
  border-radius: 6px;
  outline: 0;
  width: 100%;
`;

export function Input({
  value = "",
  error = false,
  onChange,
  errorMessages,
  number = false,
  dataId,
  disabled = false,
  placeholder = "",
  suffix,
}: InputProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    number
      ? event.target.value
          .split("")
          .every((char) => !isNaN(parseInt(char, 10))) && onChange(event)
      : onChange(event);
  };
  return (
    <>
      <Container>
        <StyledInput
          value={value}
          $error={error}
          onChange={handleChange}
          data-id={dataId}
          disabled={disabled}
          placeholder={placeholder}
        />
        {suffix && <TypographyWrapper>{suffix}</TypographyWrapper>}
      </Container>
      <ErrorMessage
        errorMessage={
          errorMessages && errorMessages.find((message) => message !== "")
        }
      />
    </>
  );
}
